/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Offer } from 'types/entities/Offer'
import { UiTableCell, UiTableRow } from 'components/Ui/UiTable'
import { hasOfferReservation, getTargetOfferCalculation } from 'utils/offers/offersUtils'
import { getPackagesCartPersonsCount } from 'utils/utility'
import { currencyNumberFormat } from 'utils/utility'
import { driverName } from 'utils/driverUtils'
import Dates from 'utils/Dates'
import UiOfferStatusPill from 'components/Ui/UiOfferStatusPill'

interface EditCompanyModalOfferItemProps {
    offer: Offer
    onClick: (offer: Offer) => void
}

const EditCompanyModalOfferItem: React.FC<EditCompanyModalOfferItemProps> = ({
    offer,
    onClick,
}) => {
    const { t } = useTranslation()
    const primaryCart = offer.packagesCart ?? getTargetOfferCalculation(offer.calculations, offer)?.packagesCart ?? null
    const persons = getPackagesCartPersonsCount(primaryCart)
    const value = primaryCart?.price ?? null
    const packageCategory = primaryCart?.category ?? null

    return (
        <UiTableRow
            className="EditCompanyModalOfferItem"
            key={`${offer.id}`}
            onClick={() => onClick(offer)}
        >
            <UiTableCell>{offer.id}</UiTableCell>
            <UiTableCell>{offer.number || <span className="text-gray-400">-</span>}</UiTableCell>
            <UiTableCell>{offer.date ? Dates.date(offer.date) : <span className="text-gray-400">-</span>}</UiTableCell>
            <UiTableCell><UiOfferStatusPill status={offer.status} /></UiTableCell>
            <UiTableCell>{packageCategory || <span className="text-gray-400">-</span>}</UiTableCell>
            <UiTableCell>{persons > 0 ? persons : <span className="text-gray-400">-</span>}</UiTableCell>
            <UiTableCell>{value != null ? currencyNumberFormat(value) : <span className="text-gray-400">-</span>}</UiTableCell>
            <UiTableCell>{offer.seller ? driverName(offer.seller) : <span className="text-gray-400">-</span>}</UiTableCell>
            <UiTableCell>{hasOfferReservation(offer) ? t('Yes') : t('No')}</UiTableCell>
            <UiTableCell>{offer.valid_until ? Dates.date(offer.valid_until) : <span className="text-gray-400">-</span>}</UiTableCell>
        </UiTableRow>
    )
}

export default EditCompanyModalOfferItem
